import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { PayloadSubjectUtils } from "./IPayloadProps";

export interface ITermsProps {
  payload: AuthorizationResponsePayload;
  onTermsAccepted: (checked: boolean) => void;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: ITermsProps) => {
  // const subjects = new PayloadSubjectUtils();
  // const dateOfBirth = subjects?.getSubjects(props.payload)?.dateOfBirth;
  const [checked, setChecked] = useState(false);

  function isOver18(birthday: string) {
    if (!birthday) return false;
    let optimizedBirthday = birthday.replace(/-/g, "/");
    let myBirthday: Date = new Date(optimizedBirthday);
    let currentDateString = new Date().toJSON().slice(0, 10) + " 01:00:00";
    let currentDate: Date = new Date(Date.parse(currentDateString));
    let myAge = ~~(
      (currentDate.getTime() - myBirthday.getTime()) /
      31557600000
    );

    if (myAge < 18) return false;
    return true;
  }

  const termsChanged = (e: any) => {
    setChecked(e.target.checked);
    props.onTermsAccepted(e.target.checked);
  };

  return (
    <Container style={{ minHeight: "150px", width: "50%", margin: "auto" }}>
      <Container
        style={{ textAlign: "left", display: "inline-block", width: "auto" }}
      >
        <span>By clicking "Accept" I agree that:</span> <br></br>
        <span>
          I have read and accepted the <a href="#">User Agreement</a>
          <br></br>
        </span>
        <span>
          I have read and accepted the <a href="#">Privacy Policy</a>
          <br></br>
        </span>
        {/* <span>
          I am at least 18 years old&nbsp;
          <img
            src="https://freesvg.org/img/kuba-icon-ok.png"
            style={{
              width: "20px",
              display: isOver18(dateOfBirth) ? "inline" : "none",
            }}
          ></img>
        </span> */}
        <br />
        <br />
        <span>
          <label>
            <input
              type="checkbox"
              checked={checked}
              onChange={termsChanged}
              autoFocus
            />
            <span> Accept </span>{" "}
          </label>
        </span>
      </Container>
    </Container>
  );
};
